import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './tramites.css';
import styles from './tramites.module.css';
import { tramitesLista } from '../../json/tramitesItem';

const Tramites = () => {
    useEffect(() => {
        window.scrollTo(0,0);
    }, []);
    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h1>Trámites</h1>
                    </div>
                </div>
            </div>
            <div className='row'>
            {
                tramitesLista.map((item, index)=>(
                    <div key={index} className='col-md-4 col-sm-6 col-12 transparencia_item'>
                        <div>
                            <Link to={item.tramitesLista_link}>
                                <div className={ styles.item }>
                                    {/*<div className={ styles.icon }>*/}
                                    {/*    <i className={item.icon}></i>*/}
                                    {/*</div>*/}
                                    <div>
                                        {item.tramitesLista_nombre}
                                    </div>
                                </div>
                            </Link>
                            <br></br>
                            {item.tramitesLista_descripcion}

                        </div>
                    </div>
                ))
            }
            </div>
            <div className='row'>
                    <div className='col_12'>
                        <div className='warning_title'>
                            <h4>Avisos de privacidad</h4>
                        </div>
                    </div>
                    <div className='warning'>
                        <a className='title_section' href='https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/AP/AP-DLC.pdf' target='_blank'>Dirección de Licitaciones y Contratos</a>
                        <a className='title_section' href='https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/AP/AP-DGCCE.pdf' target='_blank'>Dirección General de Conservación de Carreteras Estatales</a>
                        <a className='title_section' href='https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/AP/AP-SDUS.pdf' target='_blank'>Subsecretaría de Desarrollo Urbano Sostenible</a>
                        <a className='title_section' href='https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/AP/AP-DGIDUS.pdf' target='_blank'>Dirección General de Imagen y Desarrollo Urbano Sostenible</a>
                    </div>
                </div>
        </div>
    )
}

export default Tramites